/**
 * Navigation Breadcrumbs Component
 *
 * Provides contextual breadcrumb navigation based on current route.
 */

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useNavigationBreadcrumbs } from '../../hooks/useNavigation';

const NavigationBreadcrumbs: React.FC = () => {
  const location = useLocation();
  const breadcrumbs = useNavigationBreadcrumbs(location.pathname);

  // Don't show breadcrumbs on dashboard home
  if (location.pathname === '/dashboard' || location.pathname === '/dashboard/') {
    return null;
  }

  // Don't show if no breadcrumbs
  if (breadcrumbs.length <= 1) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-4">
      {breadcrumbs.map((breadcrumb, index) => (
        <React.Fragment key={breadcrumb.href}>
          {index > 0 && (
            <svg
              className="w-4 h-4 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          )}
          {index === breadcrumbs.length - 1 ? (
            // Current page - not clickable
            <span className="font-medium text-gray-900">{breadcrumb.name}</span>
          ) : (
            // Previous pages - clickable
            <Link
              to={breadcrumb.href}
              className="hover:text-gray-900 transition-colors"
            >
              {breadcrumb.name}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default NavigationBreadcrumbs;